import React, { useState } from 'react';
import { X, Loader2, Link2, Ban } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { MandantAktePicker } from './MandantAktePicker';

export const ZuordnenDialog = ({ item, onClose, onDone }) => {
  const z = item.zuordnung || {};
  const [sel, setSel] = useState(z.mandanten_nr ? { mandanten_nr: z.mandanten_nr, case_id: z.case_id } : null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const save = async (ignorieren = false) => {
    setBusy(true); setErr('');
    try {
      const r = await api.post('/register/zuordnen', ignorieren ? { area: item.area, id: item.id, ignorieren: true } : { area: item.area, id: item.id, mandanten_nr: sel.mandanten_nr, case_id: sel.case_id });
      onDone(r.data.zuordnung);
    } catch (e) { setErr(e?.response?.data?.detail || 'Zuordnung fehlgeschlagen'); setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="zuordnen-dialog">
      <div className="bg-white w-full max-w-lg shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B3A5C]"><Link2 className="w-4 h-4 text-[#b8893d]" /> Mandant & Akte zuordnen</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="zuordnen-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <div className="px-5 py-3 bg-[#fbf7f0] border-b border-gray-100 text-xs text-[#34536b] space-y-0.5">
          <p><span className="tracking-wider text-[#b8893d]">{item.area_label.toUpperCase()}</span> · <strong className="text-[#1B3A5C]">{item.titel}</strong></p>
          <p>{item.name || '—'} · {item.email || 'keine E-Mail'}{item.angabe_mnr ? ` · Angabe M-Nr. ${item.angabe_mnr}` : ''}{item.angabe_az ? ` · Angabe ${item.angabe_az}` : ''}</p>
        </div>
        <div className="p-5">
          <MandantAktePicker value={sel} onChange={setSel} initialQuery={item.angabe_mnr || item.email || ''} />
          {err && <p className="mt-3 px-2 py-1 text-xs text-red-700 bg-red-50" data-testid="zuordnen-error">{err}</p>}
        </div>
        <div className="flex items-center justify-between gap-2 px-5 py-3 border-t border-gray-100">
          <button type="button" onClick={() => save(true)} disabled={busy} data-testid="zuordnen-ignorieren" title="Kein Mandant (z. B. Interessent) – aus der Liste entfernen"
            className="inline-flex items-center gap-1 text-[11px] tracking-wider text-[#7a8a99] hover:text-rose-700"><Ban className="w-3.5 h-3.5" /> KEIN MANDANT</button>
          <button type="button" onClick={() => save(false)} disabled={busy || !sel?.mandanten_nr} data-testid="zuordnen-speichern"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors disabled:opacity-40">
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} ZUORDNEN
          </button>
        </div>
      </div>
    </div>
  );
};

export default ZuordnenDialog;
